module.exports = __webpack_public_path__ + "media/images/logo_black-1c0f6003f432b2b35689a25eb5a3ce65.png";